import { app_url } from 'app_config';
import Breadcrumb from 'components/Common/Breadcrumb';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Container, CardBody, Card, UncontrolledAccordion, AccordionItem, AccordionHeader, AccordionBody, Col, Row } from "reactstrap"

import AllSingleItems from '../Single Item Master';
import { usePermissionData } from 'AppContext';

const DeadlineMaster = () => {

    const { tab_name } = useParams()
    const navigate = useNavigate()

    const { checkAccess, permissions } = usePermissionData()

    const [tabs, setTabs] = useState([]);

    useEffect(() => {
        if (permissions) {
            const newTabs = [];
            // if (checkAccess(11, 'view')) newTabs.push("VAT-period");
            if (checkAccess(12, 'view')) newTabs.push("payroll-frequency");
            // if (checkAccess(13, 'view')) newTabs.push("management-account-frequency");
            setTabs(newTabs); // Update the state with the new array 
        }
    }, [permissions])

    useEffect(() => {
        if (!tab_name && tabs.length) {
            navigate(`${app_url}master/deadline-master/${tabs[0]}`)
        }
    }, [tab_name, tabs])

    return (
        <div>
            <div className="page-content mb-5">
                <Container fluid>
                    <Breadcrumb title={"Dashboard"} breadcrumbItem={"Deadline Master"} />
                    <div>
                        <Row>
                            <Col md={2} className='pe-1'>
                                <Card>
                                    <CardBody className=' rounded custom_side_nav p-2'>
                                        {
                                            tabs.map((tab) => {
                                                return (
                                                    <div key={tab} className='mb-2'>
                                                        <Link
                                                            to={`${app_url}master/deadline-master/${tab}`}
                                                            className={`side_navlink text-capitalize ${tab === tab_name && 'bg-white fw-bold'}`}
                                                        >

                                                            {tab.replaceAll('-', ' ')}</Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={10}>
                                <Card>
                                    <CardBody>
                                        {/* {
                                            (tab_name === 'VAT-period') &&
                                            <AllSingleItems
                                                api_name={"vat-period"}
                                                heading={"VAT Period"}
                                                title={"VAT Period"}
                                                fieldName={"vatPeriod"}
                                                isAddDelete={false}
                                                module_id={11}
                                            />
                                        } */}

                                        {
                                            (tab_name === 'payroll-frequency') &&
                                            <AllSingleItems
                                                api_name={"payroll-frequency"}
                                                heading={"Payroll Frequency"}
                                                title={"Payroll Frequency"}
                                                fieldName={"payrollFrequency"}
                                                isAddDelete={false}
                                                isAction={false}
                                                module_id={12}
                                            />
                                        }

                                        {/* {
                                            (tab_name === 'management-account-frequency') &&
                                            <AllSingleItems
                                                api_name={"management-account-frequency"}
                                                heading={"Account Frequency"}
                                                title={"Management Account Frequency"}
                                                fieldName={"managementAccountFrequency"}
                                                module_id={13}
                                            />
                                        } */}



                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default DeadlineMaster